import { suvoProcurementCategoryHierarchy } from '@suvo/shared/suvo-tenders';
import { ALL_CONTINENTS, CONTINENT_COUNTRIES } from './data/country-continents';
import type {
  IDataSourceDefinitionPresetOptionItem,
  TDataSourceDefinitionPresetSections,
} from './interfaces';

export const tendersProducts: IDataSourceDefinitionPresetOptionItem[] =
  suvoProcurementCategoryHierarchy
    .find(({ name, value }) => value === '01' || name === 'Rail' || name === 'Rail Industry')
    ?.items.map((category) => ({
      name: category.name,
      value: `01-${category.value}`,
      items:
        category.items?.map((subCategory) => ({
          name: subCategory.name,
          value: `01-${category.value}-${subCategory.value}`,
        })) ?? [],
    })) ?? [];

const TENDERS_CONTINENT_REGION_ID_MAP: Record<string, string> = {
  Africa: '0100',
  Asia: '03',
  Europe: '0500',
  'North America': '0203',
  'South America': '0204',
  Oceania: '0400',
};

const tendersContinents = ALL_CONTINENTS.filter(
  (continent) => TENDERS_CONTINENT_REGION_ID_MAP[continent.name],
).map((continent) => ({
  ...continent,
  value: TENDERS_CONTINENT_REGION_ID_MAP[continent.name],
}));

const childProducts: Record<string, IDataSourceDefinitionPresetOptionItem[]> = {};

tendersProducts.forEach((product) => {
  childProducts[product.name] = product.items ?? [];
});

export const TENDERS_NEW_FILTERS_SECTIONS: TDataSourceDefinitionPresetSections = {
  name: 'tenders',
  shortCode: 'tenders',
  sections: [
    {
      options: [
        {
          filterMethod: 'combined-nested-checkboxes',
          filterMethodConfig: {
            title: 'Location',
            showChildrenLabel: 'Show countries',
            enableShowChildren: true,
            parentData: tendersContinents,
            parentKeyName: 'regionIds',
            parentLabel: 'continent',
            childData: CONTINENT_COUNTRIES,
            childKeyName: 'countryCodes',
            locationMode: 'countries-only',
            countriesKeyName: 'countryCodes',
            toggleGroupParentKey: 'value',
            toggleGroupChildKey: 'value',
            optionsColumns: 3,
          },
          filterPropertyKeys: ['regionIds', 'countryCodes'],
        },
      ],
    },
    {
      options: [
        {
          filterMethod: 'combined-nested-checkboxes',
          filterMethodConfig: {
            title: 'Products',
            showChildrenLabel: 'Show products',
            enableShowChildren: true,
            parentData: tendersProducts,
            parentKeyName: 'categories',
            parentLabel: 'Product category',
            childData: childProducts,
            childKeyName: 'categories',
            toggleGroupParentKey: 'value',
            toggleGroupChildKey: 'value',
          },
          filterPropertyKeys: ['categories', 'categories'],
        },
      ],
    },
    {
      options: [
        {
          filterMethod: 'keywords',
          filterMethodConfig: {
            title: 'Keywords',
            label: 'Any keywords',
          },
          filterPropertyKeys: ['search'],
        },
      ],
    },
  ],
};
